import type { QuickSearchAssetV2Fragment as QuickSearchAssetFragment } from '../gql/generated/QuickSearchAssetV2';

export const getAssetFileSize = (asset: QuickSearchAssetFragment) => {
  if (asset.__typename === 'FolderAsset') {
    return asset.filesize ?? undefined;
  }

  return 'media' in asset ? asset.media?.filesize : undefined;
};
